import React, { PureComponent } from 'react';
import SVGSpriteUrl from './assets/icon-sprite.svg';
import styled from 'styled-components';
import 'tippy.js/dist/tippy.css';
import { CSVLink } from 'react-csv';

const DownLoadButtonButton = styled.button`
  background-color: transparent;
  padding: 0;
  border: 0;
  cursor: pointer;
  vertical-align: middle;
  margin-left: auto;
  margin-right: 0;
  position: absolute;
  bottom: 6px;
`;

const IconSVG = styled.svg`
  pointer-events: none;
  max-width: 14px;
  max-height: 14px;
  fill: ${props => props.iconColor};
  stroke: ${props => props.iconColor};
`;

const IconSVGWrapper = styled.div`
  display: inline-block;
  width: ${props => props.iconWidth};
  height: ${props => props.iconHeight};
`;

class DownLoadButton extends PureComponent {
  render() {
    return (
      <DownLoadButtonButton type="button">
        <CSVLink
          data={this.props.csvData}
          separator={';'}
          filename={this.props.title + '.csv'}
        >
          <IconSVGWrapper
            iconWidth={this.props.iconWidth}
            iconHeight={this.props.iconHeight}
          >
            <IconSVG iconColor={this.props.iconColor}>
              <use href={`${SVGSpriteUrl}#icon-save`} />
            </IconSVG>
          </IconSVGWrapper>
        </CSVLink>
      </DownLoadButtonButton>
    );
  }
}

export default DownLoadButton;
